module.exports = {
      id: "gemini-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#gemini",
      toString: function () {
        return this.url;
      }
    }